/**
 * @generated SignedSource<<ffb665028ffa6bfb61b3fb05e14b08b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type ScrapActionEnum = "scrap_delete" | "scrap_image_update" | "scrap_task_restore" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ScrapSourceScrapPaginator_scrapSource$data = {
  readonly id: string;
  readonly scraps: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly actions: ReadonlyArray<ScrapActionEnum>;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ScrapItem_scrap">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"ScrapSourceScrapConnectionDataTable_scrapConnection">;
  };
  readonly " $fragmentType": "ScrapSourceScrapPaginator_scrapSource";
};
export type ScrapSourceScrapPaginator_scrapSource$key = {
  readonly " $data"?: ScrapSourceScrapPaginator_scrapSource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScrapSourceScrapPaginator_scrapSource">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "scraps"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ScrapSourceScrapPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ScrapSourceScrapPaginator_scrapSource",
  "selections": [
    {
      "alias": "scraps",
      "args": null,
      "concreteType": "ScrapConnection",
      "kind": "LinkedField",
      "name": "__ScrapSourceScrapPaginator_scrapSource_scraps_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ScrapEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Scrap",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "actions",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ScrapItem_scrap"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ScrapSourceScrapConnectionDataTable_scrapConnection"
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "ScrapSource",
  "abstractKey": null
};
})();

(node as any).hash = "f896f7a892f7b12c0c5726cd7c86c8cb";

export default node;
